import * as React from "react"
import { FC, useState } from "react"
import styled from "styled-components"
import MenuItem from "./MenuItem"
import { black, borderGrey, grey } from "../../constants/colors"
import { desktop, largeDesktop } from "../../constants/screenSizes"
import ImageType from "../../model/ImageType"
import { MenuItemType } from "../../model/MenuItemType"

export const ItemSubBackgroundContainer = styled.div`
  z-index: 30;
  position: absolute;
  display: none;
  width: 100vw;
  height: 500vh;
  left: 0;
  right: 0;
  background-color: ${black};
  opacity: 0.6;
  pointer-events: none;

  ${({ isVisible }) => (isVisible ? "display: block;" : "")}
`

export const Container = styled.div`
  z-index: 50;
  position: relative;
  display: none;
  background-color: ${grey};
  justify-content: space-around;
  border-bottom: 1px solid ${borderGrey};

  @media (min-width: ${desktop}px) {
    display: flex;
  }

  @media (max-width: ${largeDesktop}px) {
    box-sizing: border-box;
    padding-right: 10px;
    padding-left: 10px;
  }
`

export const MenuInner = styled.div`
  display: flex;
  max-width: 1200px;
  flex: 1;
  line-height: 3em;
`

export interface Menu {
  id: string
  custom: {
    featuredLink: {
      title: string
      url: string
    }
    featuredImage: ImageType
  }
  childItems: {
    nodes: Menu[]
  }
  label: string
  url: string
}

interface Props {
  menuItems: MenuItemType[]
}

const Menu: FC<Props> = ({ menuItems }) => {
  const [openedMenuItemId, setOpenedMenuItemId] = useState("")

  return (
    <>
      <ItemSubBackgroundContainer isVisible={openedMenuItemId} />
      <Container>
        <MenuInner>
          {menuItems.map(item => (
            <MenuItem
              item={item}
              key={item.label}
              openedMenuItemId={openedMenuItemId}
              setOpenedMenuItemId={setOpenedMenuItemId}
            />
          ))}
        </MenuInner>
      </Container>
    </>
  )
}

export default Menu
